/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./video-demo.vue?vue&type=template&id=765dcfa8&"
import script from "./video-demo.vue?vue&type=script&lang=ts&"
export * from "./video-demo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports